var React = require('react');

function StarFill (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48 8L60.36 33.04L88 37.08L68 56.56L72.72 84.08L48 71.08L23.28 84.08L28 56.56L8 37.08L35.64 33.04L48 8Z","fill":"#130A09","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

StarFill.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = StarFill;

StarFill.default = StarFill;
